import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Service } from '../shared/services/service';
import { Funcoes } from "../funcoes";

@Injectable()
export class TipoUnidadeService extends Service {

  constructor(
    protected http: Http,
    protected func: Funcoes
  ) {
    super();
    this.url = this.dominio + '/adm/tipo-unidade/';
  }

}



// WEBPACK FOOTER //
// ./src/app/laudos-cd/tipo-unidade.service.ts